import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Mail } from 'lucide-react';
import { toast } from 'sonner';
import axios from 'axios';
import { Logo } from '../components/Logo';
import SEOHead from '../components/SEOHead';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    try {
      await axios.post(`${API_URL}/api/auth/forgot-password`, { email: email.trim() });
      setSubmitted(true);
      toast.success('Solicitação de recuperação enviada.');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Não foi possível enviar a solicitação agora.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-white to-white flex items-center justify-center p-4" data-testid="forgot-password-page">
      <SEOHead
        title="Recuperar senha | BuscaDoutor"
        description="Recupere o acesso da sua conta BuscaDoutor."
        canonicalUrl="/esqueci-senha"
        robots="noindex, nofollow"
      />

      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center justify-center mb-8">
          <Logo size="lg" />
        </Link>

        <div className="bg-white rounded-2xl border border-slate-100 shadow-xl p-8">
          <Link to="/login" className="inline-flex items-center gap-2 text-sm text-slate-600 hover:text-primary mb-6">
            <ArrowLeft className="w-4 h-4" />
            Voltar para login
          </Link>

          <div className="mb-8">
            <h1 className="text-2xl font-bold text-slate-900 mb-2">Recuperar senha</h1>
            <p className="text-slate-600">
              Informe o email da conta para solicitar a recuperação.
            </p>
          </div>

          {submitted ? (
            <div className="rounded-lg border border-emerald-100 bg-emerald-50 p-4 text-sm text-emerald-900" data-testid="forgot-password-success">
              Se este email estiver cadastrado, enviaremos um link para redefinir a senha.
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-5">
              <div className="space-y-2">
                <Label htmlFor="forgot-email">Email</Label>
                <div className="relative">
                  <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" />
                  <Input
                    id="forgot-email"
                    type="email"
                    placeholder="seu@email.com"
                    value={email}
                    onChange={(event) => setEmail(event.target.value)}
                    className="pl-10 h-12"
                    required
                    data-testid="forgot-password-email"
                  />
                </div>
              </div>

              <Button
                type="submit"
                className="w-full h-12 bg-primary hover:bg-primary/90"
                disabled={loading}
                data-testid="forgot-password-submit"
              >
                {loading ? 'Enviando...' : 'Solicitar recuperação'}
              </Button>
            </form>
          )}

          <p className="mt-6 text-center text-sm text-slate-600">
            Lembrou a senha?{' '}
            <Link to="/login" className="text-primary font-medium hover:underline">
              Entrar
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
